(function () {
  var STORAGE_KEY = 'gymtier_pack_builder_size';
  var currentCart = null;
  var selectedSize = '';

  function normaliseSize(value) {
    var size = String(value || '').trim().toUpperCase().replace(/\s+/g, '');

    if (size === 'SMALL') return 'S';
    if (size === 'MEDIUM') return 'M';
    if (size === 'LARGE') return 'L';
    if (size === 'EXTRALARGE') return 'XL';
    if (size === '2XL') return 'XXL';
    if (size === 'XXXL') return '3XL';
    if (size === 'XXXXL') return '4XL';
    if (size === 'XXXXXL') return '5XL';

    return size;
  }

  function normaliseText(value) {
    return String(value || '').trim().toLowerCase();
  }

  function shopRoot() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || (window.routes && window.routes.root) || '/';
    return root.slice(-1) === '/' ? root : root + '/';
  }

  function cartViewUrl() {
    return shopRoot() + 'cart?view=ajax_side_cart';
  }

  function parseTiers(raw) {
    return String(raw || '')
      .split(',')
      .map(function (tier) {
        var parts = tier.split(':');
        return {
          qty: parseInt(parts[0], 10),
          discount: parseFloat(parts[1])
        };
      })
      .filter(function (tier) {
        return tier.qty > 0 && tier.discount > 0;
      })
      .sort(function (a, b) {
        return a.qty - b.qty;
      });
  }

  function parseVariants(card) {
    var raw = card.getAttribute('data-pack-builder-variants') || '[]';

    try {
      return JSON.parse(raw);
    } catch (error) {
      return [];
    }
  }

  function parseProductJson(card) {
    var raw = card.getAttribute('data-json-product') || '{}';

    try {
      return JSON.parse(raw);
    } catch (error) {
      return {};
    }
  }

  function parseBundleConfig(card) {
    var raw = card.getAttribute('data-pack-builder-bundle-config') || '';

    if (!raw) return null;

    try {
      return JSON.parse(raw);
    } catch (error) {
      return null;
    }
  }

  function enhanceCollectionCards() {
    var productItems = Array.prototype.slice.call(document.querySelectorAll('[data-pack-builder-cards="true"] .product-item'));

    productItems.forEach(function (item) {
      if (item.closest('[data-pack-builder-card]')) return;

      var productData = parseProductJson(item);
      var handle = item.getAttribute('data-product-handle') || productData.handle || '';
      var variants = Array.isArray(productData.variants) ? productData.variants : [];
      var bundleConfig = productData.bundleConfig || null;
      var button = document.createElement('button');
      var status = document.createElement('div');

      item.classList.add('pack-builder-card', 'collection-pack-builder-card', 'collection-pack-builder-card--direct');
      item.setAttribute('data-pack-builder-card', '');
      if (handle) item.setAttribute('data-product-handle', handle);
      item.setAttribute('data-pack-builder-variants', JSON.stringify(variants));
      if (bundleConfig) item.setAttribute('data-pack-builder-bundle-config', JSON.stringify(bundleConfig));

      button.type = 'button';
      button.className = 'pack-builder-card__add';
      button.setAttribute('data-pack-builder-add', '');
      button.textContent = 'ADD ITEM';

      status.className = 'pack-builder-card__status';
      status.setAttribute('data-pack-builder-card-status', '');
      status.setAttribute('aria-live', 'polite');

      item.appendChild(button);
      item.appendChild(status);
    });
  }

  function variantValues(variant) {
    var values = [];

    if (Array.isArray(variant.options)) values = values.concat(variant.options);
    if (variant.option1) values.push(variant.option1);
    if (variant.option2) values.push(variant.option2);
    if (variant.option3) values.push(variant.option3);

    return values.filter(Boolean);
  }

  function variantMatchesSize(variant, size) {
    var wantedSize = normaliseSize(size);
    return variantValues(variant).some(function (value) {
      return normaliseSize(value) === wantedSize;
    });
  }

  function variantMatchesColour(variant, colour) {
    if (!colour) return true;

    var wantedColour = normaliseText(colour);
    return variantValues(variant).some(function (value) {
      return normaliseText(value) === wantedColour;
    });
  }

  function findCardVariant(card) {
    var variants = parseVariants(card);
    var colour = card.getAttribute('data-pack-builder-colour') || '';
    var exactAvailable = variants.find(function (variant) {
      return variant.available && variantMatchesSize(variant, selectedSize) && variantMatchesColour(variant, colour);
    });

    if (exactAvailable) return exactAvailable;

    var exactVariant = variants.find(function (variant) {
      return variantMatchesSize(variant, selectedSize) && variantMatchesColour(variant, colour);
    });

    if (exactVariant) return exactVariant;

    return variants.find(function (variant) {
      return variant.available && variantMatchesSize(variant, selectedSize);
    }) || variants.find(function (variant) {
      return variantMatchesSize(variant, selectedSize);
    }) || null;
  }

  function bundleSizeEntry(card, variant) {
    var config = parseBundleConfig(card);
    var sizes = config && Array.isArray(config.sizes) ? config.sizes : [];
    var wantedSize = normaliseSize(selectedSize);

    if (!wantedSize && variant) {
      variantValues(variant).some(function (value) {
        var size = normaliseSize(value);
        if (!size) return false;
        wantedSize = size;
        return true;
      });
    }

    if (!sizes.length || !wantedSize) return null;

    return sizes.find(function (size) {
      return normaliseSize(size.size || size.name || size.title) === wantedSize;
    }) || null;
  }

  function hasAvailabilityFlag(item) {
    return item && (
      typeof item.available === 'boolean' ||
      typeof item.stockAvailable === 'boolean' ||
      typeof item.componentAvailable === 'boolean'
    );
  }

  function itemIsAvailable(item) {
    if (!item) return true;
    if (item.available === false) return false;
    if (item.stockAvailable === false) return false;
    if (item.componentAvailable === false) return false;
    return true;
  }

  function bundleComponentsAvailable(card, variant) {
    var size = bundleSizeEntry(card, variant);
    var rows = [];

    if (!size) return null;
    if (typeof size.available === 'boolean') return size.available;

    ['components', 'componentQuantities', 'slots', 'options'].forEach(function (key) {
      if (Array.isArray(size[key])) rows = rows.concat(size[key]);
    });

    if (!rows.some(hasAvailabilityFlag)) return null;
    return rows.every(itemIsAvailable);
  }

  function cardVariantAvailable(card, variant) {
    if (!variant) return false;

    var bundleAvailable = bundleComponentsAvailable(card, variant);
    if (bundleAvailable !== null) return bundleAvailable;

    return variant.available !== false;
  }

  function cards() {
    enhanceCollectionCards();
    return Array.prototype.slice.call(document.querySelectorAll('[data-pack-builder-card]'));
  }

  function sizeButtons(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-pack-builder-size-button]'));
  }

  function availableSizes(root) {
    return sizeButtons(root).map(function (button) {
      return normaliseSize(button.getAttribute('data-size'));
    });
  }

  function packHandles() {
    return cards().reduce(function (handles, card) {
      var handle = card.getAttribute('data-product-handle');
      if (handle) handles.add(handle);
      return handles;
    }, new Set());
  }

  function findCartSize(cart, root) {
    if (!cart || !Array.isArray(cart.items)) return '';

    var sizes = availableSizes(root);
    var handles = packHandles();

    for (var index = 0; index < cart.items.length; index += 1) {
      var item = cart.items[index];

      if (handles.size && item.handle && !handles.has(item.handle)) continue;

      var values = [];
      if (Array.isArray(item.variant_options)) values = values.concat(item.variant_options);
      if (Array.isArray(item.options_with_values)) {
        item.options_with_values.forEach(function (option) {
          values.push(option.value);
        });
      }
      if (item.variant_title) values = values.concat(String(item.variant_title).split('/'));

      for (var valueIndex = 0; valueIndex < values.length; valueIndex += 1) {
        var size = normaliseSize(values[valueIndex]);
        if (sizes.indexOf(size) !== -1) return size;
      }
    }

    return '';
  }

  function setSelectedSize(root, size) {
    var nextSize = normaliseSize(size);
    var buttons = sizeButtons(root);
    var matchedButton = buttons.find(function (button) {
      return normaliseSize(button.getAttribute('data-size')) === nextSize;
    });

    if (!matchedButton) matchedButton = buttons[0];
    if (!matchedButton) return;

    selectedSize = normaliseSize(matchedButton.getAttribute('data-size'));
    root.setAttribute('data-selected-size', selectedSize);

    buttons.forEach(function (button) {
      var isActive = normaliseSize(button.getAttribute('data-size')) === selectedSize;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-checked', isActive ? 'true' : 'false');
    });

    var selectedLabel = root.querySelector('[data-pack-builder-selected-size]');
    if (selectedLabel) selectedLabel.textContent = selectedSize;

    try {
      window.localStorage.setItem(STORAGE_KEY, selectedSize);
    } catch (error) {}

    syncCards();
  }

  function observeCards(root) {
    if (!window.MutationObserver) return;

    var syncTimer = null;
    var observer = new MutationObserver(function (mutations) {
      var shouldSync = mutations.some(function (mutation) {
        return Array.prototype.slice.call(mutation.addedNodes || []).some(function (node) {
          if (!node || node.nodeType !== 1) return false;
          return node.matches && (
            node.matches('[data-pack-builder-card]') ||
            node.matches('.product-item') ||
            node.querySelector('[data-pack-builder-card]') ||
            node.querySelector('.product-item')
          );
        });
      });

      if (!shouldSync) return;

      window.clearTimeout(syncTimer);
      syncTimer = window.setTimeout(function () {
        enhanceCollectionCards();
        syncCards();
        updateDiscount(root, currentCart);
      }, 50);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function syncCards() {
    cards().forEach(function (card) {
      var button = card.querySelector('[data-pack-builder-add]');
      var status = card.querySelector('[data-pack-builder-card-status]');
      var variants = parseVariants(card);
      var variant = findCardVariant(card);

      if (!button) return;

      button.removeAttribute('data-variant-id');

      if (!selectedSize || !variant) {
        button.disabled = true;
        button.textContent = selectedSize && variants.length ? 'SOLD OUT' : 'ADD ITEM';
        if (status) status.textContent = '';
        return;
      }

      var isAvailable = cardVariantAvailable(card, variant);

      button.setAttribute('data-variant-id', variant.id);
      button.disabled = !isAvailable;
      button.textContent = isAvailable ? 'ADD ITEM' : 'SOLD OUT';
      if (status) status.textContent = '';
    });
  }

  function countPackItems(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;

    var handles = packHandles();

    return cart.items.reduce(function (count, item) {
      if (handles.size && item.handle && !handles.has(item.handle)) return count;
      return count + Number(item.quantity || 0);
    }, 0);
  }

  function updateDiscount(root, cart) {
    var tiers = parseTiers(root.getAttribute('data-discount-tiers'));
    var count = countPackItems(cart);
    var highestTier = tiers[tiers.length - 1];
    var activeTier = null;
    var nextTier = null;

    tiers.forEach(function (tier) {
      if (count >= tier.qty) activeTier = tier;
      if (!nextTier && count < tier.qty) nextTier = tier;
    });

    root.querySelectorAll('[data-pack-builder-tier]').forEach(function (element) {
      var qty = parseInt(element.getAttribute('data-tier-qty'), 10);
      element.classList.toggle('is-unlocked', count >= qty);
    });

    var summary = root.querySelector('[data-pack-builder-summary]');
    if (summary) {
      if (activeTier && !nextTier) {
        summary.textContent = highestTier.qty + ' FOR ' + highestTier.discount + '% OFF UNLOCKED! YOU\'VE UNLOCKED THE MAX DISCOUNT!';
      } else if (activeTier && nextTier) {
        summary.textContent = activeTier.qty + ' FOR ' + activeTier.discount + '% OFF UNLOCKED! ADD ' + Math.max(nextTier.qty - count, 1) + ' MORE FOR ' + nextTier.qty + ' FOR ' + nextTier.discount + '% OFF';
      } else if (nextTier) {
        summary.textContent = 'ADD ' + Math.max(nextTier.qty - count, 1) + ' MORE FOR ' + nextTier.qty + ' FOR ' + nextTier.discount + '% OFF';
      } else {
        summary.textContent = 'ADD ITEMS TO UNLOCK DISCOUNTS';
      }
    }

    var progress = root.querySelector('[data-pack-builder-progress]');
    var progressPercent = highestTier ? Math.max(0, Math.min(100, (count / highestTier.qty) * 100)) : 0;

    if (progress) {
      progress.style.width = progressPercent <= 0
        ? '0%'
        : progressPercent >= 99.5
          ? '100%'
          : 'calc(' + progressPercent + '% + var(--pack-builder-fill-overlap))';
      progress.classList.toggle('is-complete', progressPercent >= 99.5);
    }

    var invertedSegments = root.querySelector('[data-pack-builder-inverted-segments]');
    if (invertedSegments) {
      var clipPath = progressPercent >= 99.5
        ? 'inset(0 0 0 0)'
        : progressPercent <= 0
          ? 'inset(0 100% 0 0)'
          : 'polygon(0 0, calc(' + progressPercent + '% + var(--pack-builder-fill-overlap)) 0, calc(' + progressPercent + '% - var(--pack-builder-fill-overlap)) 100%, 0 100%)';

      invertedSegments.style.clipPath = clipPath;
      invertedSegments.style.webkitClipPath = clipPath;
    }
  }

  function fetchCart() {
    return fetch(shopRoot() + 'cart.js', { credentials: 'same-origin' }).then(function (response) {
      return response.json();
    });
  }

  function offerCountsFromElement(source) {
    function count(selector) {
      var element = source ? source.querySelector(selector) : null;
      return parseInt(element && element.textContent, 10) || 0;
    }

    return {
      'hoodie-joggers': count('.debug-offer-hoodie-joggers'),
      'tee-vest-shorts': count('.debug-offer-tee-vest-shorts'),
      'oversized-longsleeve-stringer-sweatshirt': count('.debug-offer-oversized-longsleeve-stringer-sweatshirt')
    };
  }

  function publishCart(cart, offerCounts) {
    if (!cart) return;

    document.querySelectorAll('[data-cart-count]').forEach(function (element) {
      element.textContent = cart.item_count;
    });

    document.dispatchEvent(new CustomEvent('cart-update', {
      detail: { cart: cart, offerCounts: offerCounts || null }
    }));

    document.body.dispatchEvent(new CustomEvent('cart:updated', {
      bubbles: true,
      detail: { cart: cart, offerCounts: offerCounts || null }
    }));
  }

  function refreshThemeCartHelpers(cart, offerCounts) {
    if (!window.halo) return;

    if (offerCounts && typeof window.halo.publishMixMatchOfferCounts === 'function') {
      window.halo.publishMixMatchOfferCounts(offerCounts, 'pack-builder-add');
    }

    if (offerCounts && typeof window.halo.updateProductCardOfferBadges === 'function') {
      window.halo.updateProductCardOfferBadges(offerCounts);
    }

    if (offerCounts && typeof window.halo.updateProductCardOfferPricing === 'function') {
      window.halo.updateProductCardOfferPricing(offerCounts, cart.currency || 'GBP');
    }

    if (typeof window.halo.dispatchChangeForShippingMessage === 'function') {
      window.halo.dispatchChangeForShippingMessage();
    }

    if (typeof window.halo.productCollectionCartSlider === 'function') {
      window.halo.productCollectionCartSlider();
    }

    if (typeof window.halo.updateGiftWrapper === 'function') {
      window.halo.updateGiftWrapper();
    }
  }

  function refreshSidebarCart(cart) {
    document.body.classList.add('cart-sidebar-show');

    var wrapper = document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
    if (!wrapper) {
      publishCart(cart);
      return Promise.resolve();
    }

    wrapper.classList.add('is-loading');

    return fetch(cartViewUrl(), {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
      cache: 'no-store'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Could not refresh cart.');
        return response.text();
      })
      .then(function (html) {
        var shell = document.createElement('div');
        shell.innerHTML = html;
        var offerCounts = offerCountsFromElement(shell);

        wrapper.classList.remove('is-loading');
        wrapper.innerHTML = html;
        refreshThemeCartHelpers(cart, offerCounts);
        publishCart(cart, offerCounts);
      })
      .catch(function () {
        wrapper.classList.remove('is-loading');
        publishCart(cart);
      });
  }

  function addVariant(root, card, button) {
    if (!card || !button) return;

    var variant = findCardVariant(card);
    var status = card.querySelector('[data-pack-builder-card-status]');
    var originalText = button.textContent;

    if (!variant || !cardVariantAvailable(card, variant)) return;

    button.disabled = true;
    button.textContent = 'ADDING';
    if (status) status.textContent = '';

    fetch(shopRoot() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: variant.id,
            quantity: 1,
            properties: {
              _pack_builder: 'true'
            }
          }
        ]
      })
    })
      .then(function (response) {
        return response.json().then(function (json) {
          if (!response.ok || json.status) {
            throw new Error(json.description || json.message || 'Could not add this item.');
          }

          return json;
        });
      })
      .then(fetchCart)
      .then(function (cart) {
        currentCart = cart;
        updateDiscount(root, cart);
        return refreshSidebarCart(cart).then(function () {
          button.textContent = 'ADDED';
          if (status) status.textContent = selectedSize + ' added';

          window.setTimeout(function () {
            syncCards();
            if (status) status.textContent = '';
          }, 1200);
        });
      })
      .catch(function (error) {
        button.disabled = false;
        button.textContent = originalText;
        if (status) status.textContent = error.message || 'Could not add item';

        if (window.halo && typeof window.halo.showWarning === 'function') {
          window.halo.showWarning(error.message || 'Could not add item');
        }
      });
  }

  function init() {
    var root = document.querySelector('[data-pack-builder]');
    if (!root) return;

    document.body.classList.add('pack-builder-page');

    root.addEventListener('click', function (event) {
      var sizeButton = event.target.closest('[data-pack-builder-size-button]');
      var addButton = event.target.closest('[data-pack-builder-add]');

      if (sizeButton) {
        setSelectedSize(root, sizeButton.getAttribute('data-size'));
        return;
      }

      if (addButton) {
        event.preventDefault();
        addVariant(root, addButton.closest('[data-pack-builder-card]'), addButton);
      }
    });

    document.addEventListener('click', function (event) {
      var addButton = event.target.closest('[data-pack-builder-add]');
      if (!addButton || root.contains(addButton)) return;

      event.preventDefault();
      addVariant(root, addButton.closest('[data-pack-builder-card]'), addButton);
    });

    document.addEventListener('cart-update', function (event) {
      if (!event.detail || !event.detail.cart) return;
      currentCart = event.detail.cart;
      updateDiscount(root, currentCart);
    });

    document.addEventListener('cart:updated', function (event) {
      if (!event.detail || !event.detail.cart) return;
      currentCart = event.detail.cart;
      updateDiscount(root, currentCart);
    });

    fetchCart()
      .then(function (cart) {
        currentCart = cart;
        enhanceCollectionCards();
        var sizeFromCart = findCartSize(cart, root);
        var storedSize = '';

        try {
          storedSize = window.localStorage.getItem(STORAGE_KEY) || '';
        } catch (error) {}

        setSelectedSize(root, sizeFromCart || storedSize || root.getAttribute('data-default-size'));
        updateDiscount(root, cart);
      })
      .catch(function () {
        setSelectedSize(root, root.getAttribute('data-default-size'));
        updateDiscount(root, currentCart);
      });

    window.setTimeout(function () {
      enhanceCollectionCards();
      syncCards();
    }, 250);
    observeCards(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
